
















































import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    entrezList: {
      type: Array as () => string[],
      required: false,
      default: () => [],
    },
    uniprotList: {
      type: Array as () => string[],
      required: false,
      default: () => [],
    },
  },
  setup(props) {
    const phosphoPostSearch = () => {
      const _form = document.createElement('form')
      const _input = document.createElement('input')
      let accessionIds = ''

      if (props.uniprotList) {
        accessionIds = props.uniprotList.join(',')

        _form.method = 'post'
        _form.action = 'https://www.phosphosite.org/proteinSearchSubmitAction.action'
        _form.setAttribute('target', '_blank')

        _input.setAttribute('type', 'hidden')
        _input.setAttribute('name', 'onlyPSPaccessions')
        _input.setAttribute('value', 'false')
        _input.setAttribute('name', 'accessionIds')
        _input.setAttribute('value', accessionIds)

        _form.appendChild(_input)
        document.body.appendChild(_form)
        _form.submit()
        document.body.removeChild(_form)
      }
    }

    return {
      phosphoPostSearch,
    }
  },
})
